export default "__VITE_ASSET__Hj_hPa3g__"